module.exports = __webpack_public_path__ + "img/oilfox-md.c5ac6db5.svg";